"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Undo = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.64648 6.84766C6.04492 7.44922 5.71908 8.16699 5.66895 9.00098H8.15039L4.4248 12.5283C4.37923 12.4964 1 9.00098 1 9.00098H2.93457C2.93457 8.34017 3.05762 7.69987 3.30371 7.08008C3.54981 6.46028 3.91439 5.91114 4.39746 5.43262C5.04004 4.79459 5.78971 4.36166 6.64648 4.13379C7.50326 3.90592 8.36002 3.90592 9.2168 4.13379C10.0736 4.36166 10.8255 4.79459 11.4727 5.43262C12.4342 6.40333 12.9219 7.57682 12.9355 8.95313H12.1904C12.1221 8.14648 11.7871 7.44467 11.1855 6.84766C10.584 6.25065 9.82748 5.95215 8.91602 5.95215C8.00455 5.94759 7.24805 6.24609 6.64648 6.84766Z",
    clipRule: "evenodd"
  })));
};